



































































import { Component, Vue } from 'vue-property-decorator';
import StTabs from '@/components/tabs/StTabs.vue';
import { OutgoingInvoiceEditModel, OutgoingInvoiceFilter, OutgoingInvoiceStatusEnum, TimeEntryFilter } from '@/services/api/nswag/stapiclient_generated';
import { outgoingInvoiceApi, stCustomerApi } from '@/services/st-api';
import OutgoingInvoiceTimeEntries from '@/views/OutgoingInvoice/OutgoingInvoiceTimeEntries.vue';
import OutgoingInvoiceDocument from '@/views/OutgoingInvoice/OutgoingInvoiceDocument.vue';
import OutgoingInvoiceCustomer from '@/views/OutgoingInvoice/OutgoingInvoiceCustomer.vue';
import { TabModel } from '@/components/tabs/tab-model';
import { startOfMonth } from '@/utlitities/helper';
import { UserStore } from '@/store/user-module';
import { IOutgoingInvoicePlaceholders } from '@/views/OutgoingInvoice/outgoing-invoice-helper';
import OutgoingInvoiceEmail from '@/views/OutgoingInvoice/OutgoingInvoiceEmail.vue';
import StBadge from '@/components/basic/StBadge.vue';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    StTabs,
    OutgoingInvoiceTimeEntries,
    OutgoingInvoiceDocument,
    OutgoingInvoiceCustomer,
    OutgoingInvoiceEmail,
    StBadge,
  },
})
export default class OutgoingInvoiceEdit extends Vue {
  id: number = 0;
  activeTabName: string = 'customer';
  listYear: number = 0;
  listMonth: number = 0;

  editModel: OutgoingInvoiceEditModel = OutgoingInvoiceEditModel.fromJS({ id: 0, positions: [], timeEntryIds: [], currentStatus: {} });

  //Wusste mir nicht anders zu helfen, da sonst der Watcher in OutgoingInvoiceDocument beim mounted anspringt ...
  initialized: boolean = false;

  loading = false;
  delayLoading = false;

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == 'OutgoingInvoiceEdit') {
      try {
        this.loading = true;
        const customer = await stCustomerApi.get(this.editModel.customerId!);
        this.editModel.addressTo = customer.address;
        this.editModel.addressToCalculated = this.editModel.isEInvoice ? customer.eInvoiceAddressCalculated : customer.address;
        this.editModel.toContactName = customer.contactName;
        this.editModel.toContactEmail = customer.invoiceEmail;
        this.editModel.toCompanyName = customer.name;
        this.editModel.toStreetAddress = customer.streetAddress;
        this.editModel.toZip = customer.zip;
        this.editModel.toCity = customer.city;
        this.editModel.toVatId = customer.vatId;
        this.editModel.contactNamePlaceholder = customer.contactName;
        this.editModel.description = customer.invoiceDescriptionOverwritten ? customer.invoiceDescription: customer.invoiceDescriptionSettings;
        this.editModel.paymentTerms = customer.invoicePaymentTermsOverwritten ? customer.invoicePaymentTerms : customer.invoicePaymentTermsSettings;
        this.editModel.title = customer.invoiceTitleOverwritten ? customer.invoiceTitle :customer.invoiceTitleSettings;
        this.editModel.emailTo = customer.invoiceEmail;
        this.editModel.emailText = customer.invoiceEmailTextOverwritten ? customer.invoiceEmailText : customer.invoiceEmailTextSettings;
        this.editModel.emailSubject = customer.invoiceEmailSubjectOverwritten ? customer.invoiceEmailSubject : customer.invoiceEmailSubjectSettings;
      } finally {
        this.loading = false;
      }
    }
  }

  created() {
    this.id = parseInt(this.$route.params.id);
    this.listYear = parseInt(this.$route.params.year);
    this.listMonth = parseInt(this.$route.params.month);
  }

  async loadData() {
    this.editModel = await outgoingInvoiceApi.get(this.id);
  }

  async reloadStatus(){
    try {
      this.delayLoading = true;
      const reloadedEditModel = await outgoingInvoiceApi.get(this.editModel.id!);
      this.editModel.currentStatus = reloadedEditModel.currentStatus;
    } finally {
      this.delayLoading = false;
    }
  }

  async mounted() {
    if (this.id > 0) {
      this.activeTabName = 'invoice';
      try {
        this.loading = true;
        await this.loadData();
      } finally {
        this.loading = false;
      }
      this.initialized = true;
    }
    //wenn neue Rechnung -> initialized wird erst nach Auswahl des Kunden gesetzt
  }

  get isSent() {
    return this.editModel.currentStatus?.status == OutgoingInvoiceStatusEnum.Sent;
  }

  get statusDate() {
    return this.editModel.currentStatus?.statusDate;
  }

  get statusString() {
    return this.$t(this.editModel.currentStatus?.statusTranslationString ?? '');
  }

  get lastMonthDateFrom() {
    return startOfMonth(UserStore.userNowDateTime.minus({ months: 1 })).toFormat('yyyy-MM-dd');
  }

  placeholdersChanged(placeholders: IOutgoingInvoicePlaceholders) {
    this.editModel.dateFromPlaceholder = placeholders.DateFrom;
    this.editModel.dateToPlaceholder = placeholders.DateTo;
  }

  timeEntryFilterChanged(data: TimeEntryFilter) {
    this.editModel.filterJson = JSON.stringify(data);
  }

  get isSavedInvoice() {
    return this.editModel.id;
  }

  get selectedTimeEntryIds() {
    return this.editModel.timeEntryIds ?? [];
  }

  set selectedTimeEntryIds(ids: number[]) {
    this.editModel.timeEntryIds = ids;
  }

  get customerId() {
    return this.editModel.customerId ?? 0;
  }

  goToTab(tabName: string) {
    this.activeTabName = tabName;
  }

  async customerChanged(customerId: number) {
    if (this.customerId != customerId) {
      try {
        this.delayLoading = true;
        this.editModel = await outgoingInvoiceApi.getNew(customerId, OutgoingInvoiceFilter.fromJS({}));
      } finally {
        this.delayLoading = false;
      }
      this.initialized = true;
    }
  }

  get tabs(): TabModel[] {
    let res = [
      {
        TabName: 'customer',
        Disabled: false,
      },
      {
        TabName: 'timeentries',
        Disabled: !this.customerId,
      },
      {
        TabName: 'invoice',
        Disabled: !this.customerId,
      },
    ];

    if (this.useInvoiceEmailSending) {
      res.push({
        TabName: 'email',
        Disabled: !this.isSavedInvoice,
      });
    }

    return res;
  }

  get useInvoiceEmailSending() {
    return UserStore.userSettings.useInvoiceEmailSending;
  }

  get initialActiveTab() {
    return this.id ? 'invoice' : '';
  }

  back() {
    this.$router.push({ name: 'OutgoingInvoice', params: { year: this.listYear.toString(), month: this.listMonth.toString() } });
  }
}
